<template>
    <div>
        <div class="text item">
            <el-col :span="4">{{label}}</el-col>
            <el-col :span="4"  v-if="!isTime">{{value}}</el-col>
            <el-col :span="4" v-else> {{value| dataFormat}}</el-col>
        </div>
    </div>
</template>

<script>
    export default {
        name: "display",

        props:{
            label:String,
            value:String,
            isTime:{
                default:false,
                type:Boolean
            }
        },
       data(){
            return{
                list:[]
            }
       },
        created(){

        }
    }
</script>

<style scoped>
    .text {
             font-size: 20px;
         }

    .item {
        padding: 8px 0;
        display: flex;
        justify-content: space-around;
    }

    .box-card {
        width: 900px;
    }
</style>
